module.exports = __webpack_public_path__ + "media/logos/logo-small-64135de9.svg";